import { render } from "./chatList.vue?vue&type=template&id=0730a4ca&scoped=true"
import script from "./chatList.vue?vue&type=script&lang=js"
export * from "./chatList.vue?vue&type=script&lang=js"

import "./chatList.vue?vue&type=style&index=0&id=0730a4ca&lang=scss&scoped=true"

import exportComponent from "D:\\codes\\chat28\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0730a4ca"]])

export default __exports__